import { Text, View } from '@react-pdf/renderer';

import { styles } from './styles';

type SiteInformationProps = {
  name: string | string[];
  items?: string[];
};

export function SiteInformation({ name, items }: SiteInformationProps) {
  const names = Array(name).flat();

  return (
    <View style={styles.section}>
      {names.map((name, i) => (
        <Text key={`${name}-${i}`} style={styles.bold}>
          {name}
        </Text>
      ))}

      {items?.map((item, i) => <Text key={`${item}-${i}`}>{item}</Text>)}
    </View>
  );
}
